// Project specific values for the shared alpha environment
const config = {
  appId: '1:226185667718:web:424a1b4faf523f12365d07',
  apiKey: 'AIzaSyCO_R2Tk9CPAsipPRwF59Zq9CYBITYAk-I',
  authDomain: 'linoleum-35588.firebaseapp.com',
  databaseURL: 'https://linoleum-35588.firebaseio.com',
  projectId: 'linoleum-35588',
  storageBucket: 'linoleum-35588.appspot.com',
  messagingSenderId: '226185667718',
  measurementId: 'G-LGY8K84VXS',
};

// Where does the player reside? Used when dashboards produces player urls.
// Optionally let local webpack deveserver override this via WEBPLAYER_BASE_URL
config.publicBaseUrl = process.env.WEBPLAYER_BASE_URL || 'https://linoleum-public.bambuser.com';

// Where does the embed reside?
config.embedBaseUrl = process.env.EMBED_BASE_URL || 'https://linoleum-embed.bambuser.com';

// Where does the widgets reside?
config.widgetsBaseUrl = process.env.WIDGETS_BASE_URL || 'https://linoleum-widgets.bambuser.com';

// Where does the app framework reside?
config.appFrameworkBaseUrl = process.env.APP_FRAMEWORK_BASE_URL || `https://linoleum-app-framework.bambuser.com`;

// Base url for event stream REST API
config.eventStreamBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/eventstream`;

// Base url for metrics REST API
config.metricsBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/collect`;

// Base url for client API
config.clientAPIBaseUrl = process.env.API_BASE_URL || `https://svc-stage-us.liveshopping.bambuser.com/functions/api`;

// Base url for social media API
config.socialMediaBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/functions/socialMedia`;

// Base url for client product config
config.clientProductConfigBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/functions/productConfig`;

// Base url for client Auth
config.clientAuthBaseUrl = process.env.AUTH_BASE_URL || `https://svc-stage-us.liveshopping.bambuser.com/functions/auth`;

// Base url for asset proxy (used when surfing in a srcdoc iframe with minimized player)
config.assetProxyBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/functions/assetProxy`

// Base url for widgets client API
config.widgetsAPIBaseUrl = `https://svc-stage-us.liveshopping.bambuser.com/functions/widgets`;

// Base url for App Engine widgets client API
config.widgetsAppEngineAPIBaseUrl = process.env.WIDGETS_API_BASE_URL || `https://svc-stage-us.liveshopping.bambuser.com/widgets`;

// Base url for vod
config.vodUrl = process.env.VOD_BACKEND_BASE_URL || 'https://vod-776r3hupya-uc.a.run.app';

// Base url for product catalogue
config.productCatalogueServerUrl = process.env.PRODUCT_CATALOG_SERVER_BACKEND_BASE_URL || 'https://svc-stage-us.liveshopping.bambuser.com/product-catalog';

// Base url for videoeditor-cloudrun
config.videoEditorCloudRunBaseUrl = process.env.VIDEOEDITOR_CLOUDRUN_BASE_URL || 'https://videoeditor-cloudrun-776r3hupya-uc.a.run.app';

// Return url for redirecting back to the dashboard, for example after
// email verification and sso logout
config.returnUrl = process.env.HOSTING_DASHBOARDURL || 'https://lcx-stage.bambuser.com';

// GTM tag id
config.gtmTagId = 'GTM-NQJTDBL';

// Pendo API key
config.pendoApiKey = '1f95d5c1-e361-4be8-bf0f-fa41605b7ea6';

// Public stripe key for billing page
config.stripePublicKey = 'pk_test_51IbKuwHvV77QG0tGU16GBO2Ey1m390zQXePZV4NeoMU7IcQ1aitevj8bVP0VX7R3Mu7kfApZi6uHZM09UjdOWk7S002Y14PRgN';

// Base url to image transformer service
config.imageTransformerBaseUrl = `https://us-central1-${encodeURIComponent(config.projectId)}.cloudfunctions.net/imageTransformer`;

// Base url for assets served via CF (fonts, images for customizations etc)
config.assetsCdnUrl = 'https://cdn.liveshopping.bambuser.com';

// Analytics' GCP-project
config.bigQueryProjectId = 'bambuser-analytics-stage';

// Client API for backoffice
config.backofficeBaseUrl = 'https://svc-stage-us.liveshopping.bambuser.com/functions/backoffice';

// Base url for Bambuser public REST API
config.lvsPublicAPIBaseUrl = 'https://linoleum-api.web.app';

// Base url for One-to-One embed and callWidget
config.callsEmbedUrl = process.env.CALLS_EMBED_URL || 'https://lvs-121-dev.web.app/embed.js';
config.callsWidgetUrl = process.env.CALLS_WIDGET_URL || 'https://lvs-121-dev.web.app/call-widget';

config.transcriberUrl = 'https://transcribe-us.codemines.org';

// Base url for chat parts
config.chatDashboardBaseUrl = process.env.CHAT_DASHBOARD_BASE_URL || 'https://us.dashboard.preprod.chat.bambuser.com';
config.chatWebAppBaseUrl = process.env.CHAT_WEB_APP_BASE_URL || 'https://eu.online-only.preprod.chat.bambuser.com';
config.chatApiBaseUrl = process.env.CHAT_API_BASE_URL || 'https://api.preprod.chat.bambuser.com';

module.exports = config;
